/* eslint-disable jsx-a11y/control-has-associated-label */
import { useState } from 'react';
import { motion } from 'framer-motion';
import lauraDesk from '../../../assets/laura-office-desk.png';
import { useGameStore } from '../../../stores/gameStore';
import { useDragStore } from '../../../stores/dragStore';
import { useChatStore } from '../../../stores/chatStore';
import { useEmailStore } from '../../../stores/emailStore';
import { useFileStore } from '../../../stores/fileStore';
import { playSound, playBackgroundMusic } from '../../../utils/soundService';

export function Start() {
  const [showConfirm, setShowConfirm] = useState(false);
  const setShowGameStart = useGameStore((state) => state.setShowGameStart);
  const gameFinished = useGameStore((state) => state.gameFinished);
  const setGameFinished = useGameStore((state) => state.setGameFinished);
  const resetGameStore = useGameStore((state) => state.resetToInitialState);
  const resetDragStore = useDragStore((state) => state.resetToInitialState);
  const resetChatStore = useChatStore((state) => state.resetToInitialState);
  const resetEmailStore = useEmailStore((state) => state.resetToInitialState);
  const resetFileStore = useFileStore((state) => state.resetToInitialState);

  const handlePlay = () => {
    playSound('click');
    playBackgroundMusic();
    setShowGameStart(false);
    setGameFinished(false);
  };

  const handleRestart = () => {
    if (gameFinished) {
      setShowConfirm(true);
    } else {
      handlePlay();
    }
  };

  const handleConfirmRestart = () => {
    playSound('click');
    setShowConfirm(false);
    resetGameStore();
    resetDragStore();
    resetChatStore();
    resetEmailStore();
    resetFileStore();
    setShowGameStart(false);
    setGameFinished(false);
  };

  return (
    <div className="w-full h-screen flex items-center justify-center relative overflow-hidden">
      {gameFinished && (
        <motion.div
          className="fixed bg-white flex items-center justify-center z-50 w-screen h-screen pointer-events-none"
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ duration: 2, delay: 3, ease: 'easeInOut' }}
        >
          <p className="text-2xl font-semibold text-black">to be continued</p>
        </motion.div>
      )}

      {showConfirm && (
        <div className="fixed inset-0 bg-black/20 flex items-center justify-center z-50">
          <div className="bg-white border border-gray-300 rounded-lg shadow-lg w-96">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <h2 className="text-base font-semibold text-gray-900">Restart</h2>
            </div>

            <div className="p-4">
              <p className="text-sm text-gray-700">
                Are you sure you want to restart? All progress will be cleared.
              </p>
            </div>

            <div className="flex justify-end gap-2 p-4 border-t border-gray-200">
              <button
                onClick={() => {
                  playSound('click');
                  setShowConfirm(false);
                }}
                className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmRestart}
                className="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded hover:bg-gray-800 transition-colors"
              >
                Restart
              </button>
            </div>
          </div>
        </div>
      )}

      <motion.img
        src={lauraDesk}
        alt="Laura's Office Desk"
        className="w-full h-full object-cover absolute inset-0"
        initial={{ scale: 7 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2, ease: 'easeOut' }}
      />

      <button
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[30vw] h-[25vw] cursor-pointer z-10"
        onClick={handleRestart}
      />

      <motion.div
        className="absolute top-8 right-8 z-10 text-right"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.7 }}
      >
        <h1 className="text-4xl font-bold text-black mb-2">laura.ai</h1>
        <p className="text-lg text-gray-700 mb-6">a digital mystery</p>
      </motion.div>
    </div>
  );
}
